"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  name: 'BASIC',
  displayName: 'BASIC',
  iconName: 'mobile',
  videoQuantity: 2,
  slaTurnaround: 48,
  amendmentsQuantity: 5,
  resetPeriod: 'MONTHLY',
  userAllowance: 3,
  storageAllowance: 100,
  templatedFrom: 'BASIC',
  subStart: '',
  subEnd: '',
  custom: false
}, {
  name: 'PREMIUM',
  displayName: 'PREMIUM',
  iconName: 'camera',
  videoQuantity: 4,
  slaTurnaround: 48,
  amendmentsQuantity: 5,
  resetPeriod: 'MONTHLY',
  userAllowance: 5,
  storageAllowance: 100,
  templatedFrom: 'PREMIUM',
  subStart: '',
  subEnd: '',
  custom: false
}, {
  name: 'PROFESSIONAL',
  displayName: 'PROFESSIONAL',
  iconName: 'professional',
  videoQuantity: 8,
  slaTurnaround: 24,
  amendmentsQuantity: 5,
  resetPeriod: 'MONTHLY',
  userAllowance: 10,
  storageAllowance: 100,
  templatedFrom: 'PROFESSIONAL',
  subStart: '',
  subEnd: '',
  custom: false
}, {
  name: 'PLATINUM',
  displayName: 'PLATINUM',
  iconName: 'platinum',
  videoQuantity: 25,
  slaTurnaround: 24,
  amendmentsQuantity: 5,
  resetPeriod: 'MONTHLY',
  userAllowance: 20,
  storageAllowance: 100,
  templatedFrom: 'PLATINUM',
  subStart: '',
  subEnd: '',
  custom: false
}, {
  name: 'UNLIMITED',
  displayName: 'UNLIMITED',
  iconName: 'unlimited',
  videoQuantity: -1,
  slaTurnaround: 24,
  amendmentsQuantity: 5,
  resetPeriod: 'MONTHLY',
  userAllowance: -1,
  storageAllowance: -1,
  templatedFrom: 'UNLIMITED',
  subStart: '',
  subEnd: '',
  custom: false
}, {
  name: 'PAYG*',
  displayName: 'PAYG*',
  iconName: 'package',
  videoQuantity: 0,
  slaTurnaround: 24,
  amendmentsQuantity: 5,
  resetPeriod: 'MONTHLY',
  userAllowance: 10,
  storageAllowance: 200,
  templatedFrom: 'PAYG*',
  subStart: '',
  subEnd: '',
  custom: false
}];
exports.default = _default;